/* eslint-disable */
import React from 'react'
import Image from './Image'
import {
  FlatList,
  View,
  Text,
  ScrollView,
  StyleSheet,
  Linking,
  TouchableWithoutFeedback,
  Dimensions,
  Button,
  TouchableHighlight,
  TextInput,
  Platform,
} from 'react-native'

const containerWidth = Math.min(window.innerWidth, 680)
const styles = StyleSheet.create({
  itemsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  
  itemContainer: {
    marginBottom: 25,
    outline: '0',
  },
  
  itemTitle: {
    marginTop: 10,
    fontSize: 18,
    fontWeight: '500',
    lineHeight: 24,
    color: 'black',
    width: 400,
  },
  
  categoryTitle: {
    fontSize: 24,
    color: 'black',
    backgroundColor: 'white',
    fontFamily: 'Fugaz One',
    paddingTop: 5,
    paddingBottom: 2,
    paddingLeft: 10,
    paddingRight: 10,
    userSelect: 'none',
    alignSelf: 'center',
    zIndex: 1,
  },
  
  categoryTitleLine: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '50%',
    borderTopWidth: 2,
    borderTopColor: 'black',
  },
})

export default class SuperList extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
    }
  }
  
  onPress(item) {
    this.props.onSelected(item)
  }
  
  sortBooks(books) {
    return books.sort((firstBook, secondBook) => {
      const languagePostfix = `@${this.props.settings.languages.original}-${this.props.settings.languages.translated}`
      const firstBookLastOpened = (this.props.history[`${firstBook.id}${languagePostfix}`] || {}).lastOpened
      const secondBookLastOpened = (this.props.history[`${secondBook.id}${languagePostfix}`] || {}).lastOpened
      
      if (!firstBookLastOpened && secondBookLastOpened) return 1
      if (firstBookLastOpened && !secondBookLastOpened) return -1
      if (!firstBookLastOpened && !secondBookLastOpened) return 0
      
      return firstBookLastOpened < secondBookLastOpened ? 1 : -1
    })
  }
  
  render() {
    let books = this.sortBooks([...this.props.items])
    for (let i = books.length; i < Math.ceil(books.length / 4) * 4; i++) books[i] = null
    
    return (
      <View style={{marginTop: 62, paddingTop: 25, flex: 1, alignItems: 'center', overflow: 'auto'}}>
        <View style={{width: containerWidth}}>
        
          <View style={styles.itemsContainer}>
            {books.map((item, index) => (
              !item
                ? <View key={index} style={{width: 150, height: 225}}></View>
                : <TouchableWithoutFeedback key={index} onPress={this.onPress.bind(this, item)}>
                  <View style={styles.itemContainer}>
                    <Image
                      src={item.cover}
                      style={{
                        width: 150,
                        height: 225,
                      }}>
                    </Image>
                  </View>
                </TouchableWithoutFeedback>
            ))}
          </View>
        </View>
      </View>
    )
  }
}
